<template>
  <d2-container>
    <template slot="header">
      <el-input
        clearable
        @keyup.enter.native="getSearch"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入用户id"
        size="small"
        v-model="listQuery.accountId"
      ></el-input>
      <el-input
        clearable
        @keyup.enter.native="getSearch"
        style="width: 220px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入任务id"
        size="small"
        v-model="listQuery.taskId"
      ></el-input>
      <el-input
        clearable
        @keyup.enter.native="getSearch"
        style="width: 220px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入打卡活动id"
        size="small"
        v-model="listQuery.themeId"
      ></el-input>
      <el-input
        clearable
        @keyup.enter.native="getSearch"
        style="width: 220px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入用户证书id"
        size="small"
        v-model="listQuery.userCertId"
      ></el-input>
      <el-select
        class="filter-item"
        v-model="listQuery.status"
        placeholder="请选择状态"
        size="small"
        style="margin-right: 20px"
        clearable
      >
        <el-option
          v-for="item in isStatusList"
          :key="item.index"
          :label="item.name"
          :value="item.index"
        ></el-option>
      </el-select>
      <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="recordData"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户证书id">
        <template slot-scope="scope">
          <span>{{ scope.row.userCertId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户id">
        <template slot-scope="scope">
          <span
            @click="jumpDetails(scope.row.accountId)"
            style=" color:#2f74ff;cursor: pointer;"
          >{{ scope.row.accountId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="任务id">
        <template slot-scope="scope">
          <span>{{ scope.row.themeId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="子任务id">
        <template slot-scope="scope">
          <span>{{ scope.row.taskId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="任务标题">
        <template slot-scope="scope">
          <span
            @click="jumpTitle(scope.row.title)"
            style=" color:#2f74ff;cursor: pointer;"
          >{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="子任务标题">
        <template slot-scope="scope">
          <span>{{ scope.row.taskTitle }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="奖品快照">
        <template slot-scope="scope">
          <span>{{ scope.row.giftSnapshot }}</span>
        </template>
      </el-table-column>-->
      <el-table-column align="center" label="步数">
        <template slot-scope="scope">
          <span>{{ scope.row.step }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="内容" width="100">
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" @click="viewContent(scope.row.id)">查看</el-link>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="音频内容" width="300">
        <template slot-scope="scope">
          <aplayer
            v-if="scope.row.videoUpload.music.src != '11'"
            :music="scope.row.videoUpload.music"
          ></aplayer>
        </template>
      </el-table-column>-->
      <el-table-column  align="center" width="200" label="质量评价">
        <template slot-scope="scope">
          <el-rate
              v-model="scope.row.starLevel"
              disabled
              show-text>
          </el-rate>
        </template>
      </el-table-column>
      <el-table-column align="center" label="提交时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="审核备注">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="复核备注">
        <template slot-scope="scope">
          <span>{{ scope.row.reviewRemark }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span :class="scope.row.status == 0 ?'red':''" v-if="scope.row.status == 0 ">待审核</span>
          <span :class="scope.row.status == 1 ?'green':''" v-if="scope.row.status == 1 ">已完成</span>
          <span v-if="scope.row.status == 2 ">已拒绝</span>
          <span :class="scope.row.status == 3 ?'blue':''" v-if="scope.row.status == 3 ">待复核</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <span v-permission:function="['recordManger:btn_toe']">
            <el-button
              size="small"
              type="primary"
              @click="getExamine(scope.row.id, scope.row.accountId)"
              v-if="scope.row.status == 0"
              style="margin-top: 10px;"
            >审核</el-button>
          </span>
          <span v-permission:function="['recordManger:btn_complex']">
            <el-button
              v-if="scope.row.status == 3"
              size="small"
              type="success"
              style="margin-top: 10px;"
              @click="getToReview(scope.row.id,scope.row.sendAttrSnapshot,scope.row.starLevel, scope.row.accountId)"
            >复审</el-button>
          </span>
            <el-button v-if="scope.row.status === 1 &&  scope.row.sourceStatus === 0"   @click= "addToResourceShow(scope.row.id)" size="mini" style="margin-top: 10px;" type="success">
                添加至资源库
            </el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>

      <el-dialog :visible.sync="showAddToResource" append-to-body>
          <el-form>
              <el-form-item label="分组" prop="categoryId">
                  <el-select v-model="addToResourceForm.categoryId" filterable placeholder="请选择">
                      <el-option
                              v-for="item in categoryList"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key">
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="标签">
                  <el-select v-model="addToResourceForm.tagIds"
                             clearable
                             filterable
                             multiple placeholder="请选择">
                      <el-option
                              v-for="item in tagList"
                              :key="item.key"
                              :label="item.value"
                              :value="item.key">
                      </el-option>
                  </el-select>
              </el-form-item>
              <div class="footer">
                  <el-button @click="()=>showAddToResource = false">取 消</el-button>
                  <el-button type="success" @click="addToResource">确定</el-button>
              </div>
          </el-form>
      </el-dialog>

    <el-dialog title="审核" :visible.sync="dialogFormVisible" fullscreen>
      <el-row>
        <el-col span="17">
          <content-panel :id="form.id"></content-panel>
          <div v-if="dialogFormVisible" class="draggable-element">
            <el-form :model="form"  :rules="rules" ref="form" label-width="100px">
              <div class="disDiv">
                <div v-for="(item,index) in form.attVal" :key="index">
                  <el-form-item label="能力属性：" :prop="'attVal.' + index + '.attrId'">
                    <el-select
                        v-model="item.attrId"
                        clearable
                        placeholder="请选择能力属性"
                        size="small"
                        style="margin-top:5px;margin-right: 20px;"
                    >
                      <el-option
                          v-for="item2 in AbilityList"
                          :key="item2.id"
                          :label="item2.name"
                          :value="item2.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="创作评分：" :prop="'attVal.' + index + '.value'">
                    <!-- <el-input class="input" v-model.number="item.value" placeholder="请输入评分数值"></el-input> -->
                    <el-input-number size="small" :min="0" v-model="item.value"></el-input-number>
                  </el-form-item>
                  <div style="display: flex;justify-content: center;">
                    <el-button type="primary" size="mini" @click="addList">+增加</el-button>
                    <el-button type="danger" size="mini" @click="removeList(index)" v-if="index !== 0">-删除</el-button>
                  </div>
                </div>
              </div>
              <el-form-item label="质量评价：" prop="type">
                <el-rate
                    style="margin-top: 10px"
                    v-model="form.starLevel"
                    show-text>
                </el-rate>
              </el-form-item>
              <el-form-item label="审核备注" placeholder="请输入备注" prop="remark">
                <el-input v-model="form.remark"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button  type="success" @click="getAdopt('form')">通过🙆</el-button>
                <el-button type="danger" style="margin-left: 20px;" @click="getFail('form')">拒绝🙅</el-button>
                <el-button  style="margin-left: 20px;" @click="cancel('form')">关闭 ❌</el-button>
              </el-form-item>

            </el-form>
          </div>
        </el-col>
        <el-col style="margin-left: 10px" :span="5">
          <user-info :id="viewAccountId"></user-info>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="工作内容" :visible.sync="dialogViewContent">
      <content-panel :id="viewId"></content-panel>
    </el-dialog>

    <el-dialog title="复审" :visible.sync="dialogFormReview" fullscreen>
      <el-col span="17">
        <content-panel :id="formR.id"></content-panel>
        <div v-if="dialogFormReview" class="draggable-element">
          <el-form :model="formR" :rules="rules" ref="formR" label-width="140px">
            <el-form-item label="复审备注" placeholder="请输入备注" prop="remark">
              <el-input v-model="formR.remark"></el-input>
            </el-form-item>
            <div class="disDiv">
              <div v-for="(item,index) in formR.attVal" :key="index">
                <el-form-item label="能力属性：">
                  <el-select
                      v-model="item.attrId"
                      placeholder="请选择能力属性"
                      size="small"
                      style="margin-top:5px;margin-right: 20px;"
                  >
                    <el-option
                        v-for="item2 in AbilityList"
                        :key="item2.id"
                        :label="item2.name"
                        :value="item2.id"
                        :disabled="true"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="创作评分：">
                  <el-input-number :disabled="true" size="small" :min="0" v-model="item.value"></el-input-number>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="质量评价：" prop="type">
              <el-rate
                  style="margin-top: 10px"
                  v-model="formR.starLevel"
                  disabled
                  show-score >
              </el-rate>
            </el-form-item>
            <el-form-item>
              <el-button  type="success"@click="getAdospt('formR',1)">通过🙆</el-button>
              <el-button type="danger" style="margin-left: 20px;" @click="getAdospt('formR',0)">拒绝🙅</el-button>
              <el-button @click="cancesl('formR')">关闭 ❌</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col style="margin-left: 10px" :span="5">
        <user-info :id="viewAccountId"></user-info>
      </el-col>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getList,
  getPass,
  getReject,
  getPafss,
  getResject, addToResource
} from '@/api/demo/record/index'
import { attList } from '@/api/demo/attributes/index'
import aplayer from 'vue-aplayer'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
import UserInfo from '@/components/users/userInfo'
import { fileCategoryOptions, fileTagOption } from '@/api/demo/file'
import contentPanel from '@/components/ContentPanel/index.vue'

let offsetX, offsetY, draggableElement
export default {
  name: 'recordManger',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    contentPanel,
    UserInfo,
    aplayer,
    videoPlayer
  },
  data () {
    return {
      viewId: '',
      dialogViewContent: false,
      videoUpload: {
        progress: false,
        progressPercent: 0,
        successPercent: 0,
        music: {
          title: '录音',
          artist: 'mp3',
          src: '11',
          lrc: '[00:00.00]lrc here\n[00:01.00]aplayer'
        }
      },
      AbilityList: [],
      tableKey: 0,
      recordManger_btn_toe: false,
      recordManger_btn_complex: false,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        userCertId: '', // 用户证书id
        themeId: '', // 打卡活动id
        taskId: '', // 任务id
        status: '', // 状态 0 未审核 1 已审核 2 已拒绝
        accountId: '' // 用户id
      },
      listAbility: {
        currentPage: 1,
        pageSize: 20
      },
      recordData: [], // 任务列表
      total: null,
      isStatusList: [
        {
          index: 0,
          name: '未审核'
        },
        {
          index: 1,
          name: '已完成'
        },
        {
          index: 2,
          name: '已拒绝'
        },
        {
          index: 3,
          name: '待复审'
        }
      ],
      form: {
        id: '', // 记录id
        remark: '', // 审核备注
        type: 0,
        attVal: [
          {
            attrId: '',
            value: ''
          }
        ]
      },
      formR: {
        audit: 0, // 是否通过 0 未通过 1 通过
        id: '', // 记录id
        remark: '', // 审核备注
        attVal: [
          {
            attrId: '',
            value: ''
          }
        ]
      },
      rules: {
        id: [{ required: true, message: '请填写id', trigger: 'blur' }],
        remark: [{ required: true, message: '请填写备注内容', trigger: 'blur' }]
      },
      dialogFormVisible: false,
      dialogFormReview: false,
      failOrPass: true, // 判断是否审核的类型
      viewAccountId: '', // 查看用户id
      addToResourceForm: {
        categoryId: '',
        tagIds: []
      },
      categoryList: [],
      tagList: [],
      showAddToResource: false,
      currentToResourceId: ''
    }
  },
  watch: {
    $route (to, from) {
      if (this.$route.query.accountsId == undefined) {
        // this.listQuery.accountId = null;
      } else {
        this.listQuery.accountId = this.$route.query.accountsId
      }
      if (this.$route.query.themesId == undefined) {
        // this.listQuery.themeId = null;
      } else {
        this.listQuery.themeId = this.$route.query.themesId
      }
      this.getRecordList()
    }
  },
  created () {
    if (this.$route.query.accountsId == undefined) {
      // this.listQuery.accountId = null;
    } else {
      this.listQuery.accountId = this.$route.query.accountsId
    }
    if (this.$route.query.themesId == undefined) {
      // this.listQuery.themeId = null;
    } else {
      this.listQuery.themeId = this.$route.query.themesId
    }
    fileTagOption().then(res => {
      this.tagList = res
    })
    fileCategoryOptions().then(res => {
      this.categoryList = res
    })
    this.getRecordList()
    this.getAbility()
  },
  mounted () {},
  methods: {
    viewContent (id) {
      this.viewId = id
      this.dialogViewContent = true
    },
    addToResourceShow (logId) {
      this.currentToResourceId = logId
      this.showAddToResource = true
    },
    addToResource () {
      addToResource(this.currentToResourceId, this.addToResourceForm).then(res => {
        this.$message.success('添加成功')
        this.showAddToResource = false
        this.getRecordList(this.listQuery.currentPage)
      })
    },
    // 查询列表
    getAbility () {
      let that = this
      attList(that.listAbility, 4).then(res => {
        that.listLoading = true
        that.AbilityList = res.records
        that.listLoading = false
      })
    },
    // 搜索条件
    getRecordList (val) {
      let that = this
      if (val) {
        that.listQuery.currentPage = val
      } else {
        that.listQuery.currentPage = 1
      }
      getList(that.listQuery).then(res => {
        that.listLoading = true
        console.log('that.recordData4', res)
        for (let index = 0; index < res.records.length; index++) {
          if (
            res.records[index].imgContent != '' &&
            res.records[index].imgContent != null &&
            res.records[index].imgContent.indexOf(',') != -1
          ) {
            res.records[index].imgContent = res.records[index].imgContent.split(
              ','
            )
          } else if (
            res.records[index].imgContent != '' &&
            res.records[index].imgContent != null
          ) {
            res.records[index].imgContent = res.records[
              index
            ].imgContent.split()
          }
          if (
            res.records[index].videoContent != '' &&
            res.records[index].videoContent != null &&
            res.records[index].videoContent.indexOf(',') != -1
          ) {
            res.records[index].videoContent = res.records[
              index
            ].videoContent.split(',')
            let key11 = 'arrList'
            let value11 = []
            res.records[index][key11] = value11
            for (let i = 0; i < res.records[index].videoContent.length; i++) {
              let arr = {
                playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                autoplay: false, // 如果为true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 是否视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                  {
                    type: 'video/mp4', // 类型
                    src: res.records[index].videoContent[i] // url地址
                  }
                ],
                poster: '', // 封面地址
                notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                  timeDivider: true, // 当前时间和持续时间的分隔符
                  durationDisplay: true, // 显示持续时间
                  remainingTimeDisplay: false, // 是否显示剩余时间功能
                  fullscreenToggle: true // 是否显示全屏按钮
                }
              }
              res.records[index].arrList.push(arr)
            }
          } else if (
            res.records[index].videoContent != '' &&
            res.records[index].videoContent != null &&
            res.records[index].videoContent.indexOf(',') == -1
          ) {
            // console.log('1111',res.records[index].videoContent)
            // res.records[index].videoContent = res.records[
            //   index
            // ].videoContent.split("");
            let key11 = 'arrList'
            let value11 = []
            res.records[index][key11] = value11
            // for (let i = 0; i < res.records[index].videoContent.length; i++) {
            let arr = {
              playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
              autoplay: false, // 如果为true,浏览器准备好时开始回放。
              muted: false, // 默认情况下将会消除任何音频。
              loop: false, // 是否视频一结束就重新开始。
              preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              language: 'zh-CN',
              aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
              fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              sources: [
                {
                  type: 'video/mp4', // 类型
                  src: res.records[index].videoContent // url地址
                }
              ],
              poster: '', // 封面地址
              notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
              controlBar: {
                timeDivider: true, // 当前时间和持续时间的分隔符
                durationDisplay: true, // 显示持续时间
                remainingTimeDisplay: false, // 是否显示剩余时间功能
                fullscreenToggle: true // 是否显示全屏按钮
              }
            }
            res.records[index].arrList.push(arr)
            // }
          } else {
            let key11 = 'arrList'
            let value11 = []
            res.records[index][key11] = value11
          }
          let key5 = 'videoUpload'
          let value5 = {}
          res.records[index][key5] = value5
          res.records[index].videoUpload = JSON.parse(
            JSON.stringify(that.videoUpload)
          )
          // console.log(
          //   res.records[index].videoUpload,
          //   "res.records[index].videoUpload"
          // );
          if (
            res.records[index].audioContent != null &&
            res.records[index].audioContent != ''
          ) {
            res.records[index].videoUpload.music.src =
              res.records[index].audioContent
          }
        }
        that.recordData = res.records
        console.log('that.recordData', res.records)
        that.total = parseInt(res.total)
        that.listLoading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      console.log('33')
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getRecordList(val)
    },
    // 审核
    getExamine (id, accountId) {
      this.dialogFormVisible = true
      this.form.id = id
      this.viewAccountId = accountId
      setTimeout(() => {
        draggableElement = document.querySelector('.draggable-element')
        console.log('draggableElement', draggableElement)
        draggableElement.addEventListener('mousedown', this.startDrag)
      }, 100)
    },
    // 复审
    getToReview (id, sendAttrSnapshot, starLevel, accountId) {
      this.formR.id = id
      this.formR.starLevel = starLevel
      this.formR.attVal = JSON.parse(sendAttrSnapshot)
      for (let index = 0; index < this.formR.attVal.length; index++) {
        for (let index2 = 0; index2 < this.AbilityList.length; index2++) {
          if ((this.formR.attVal[index].attrId = this.AbilityList[index2].id)) {
            this.formR.attVal[index].attrId = this.AbilityList[index2].name
          }
        }
      }
      this.dialogFormReview = true
      this.viewAccountId = accountId
      setTimeout(() => {
        draggableElement = document.querySelector('.draggable-element')
        console.log('draggableElement', draggableElement)
        draggableElement.addEventListener('mousedown', this.startDrag)
      }, 100)
    },
    startDrag (e) {
      console.log('startDrag')
      offsetX = e.clientX - draggableElement.offsetLeft
      offsetY = e.clientY - draggableElement.offsetTop
      document.addEventListener('mousemove', this.dragElement)
      document.addEventListener('mouseup', this.stopDrag)
    },
    dragElement (e) {
      draggableElement.style.left = (e.clientX - offsetX) + 'px'
      draggableElement.style.top = (e.clientY - offsetY) + 'px'
    },
    stopDrag () {
      document.removeEventListener('mousemove', this.dragElement)
      document.removeEventListener('mouseup', this.stopDrag)
    },

    // 复审取消
    cancesl () {
      this.dialogFormReview = false
    },
    // 复审通过
    getAdospt (formName, audit) {
      let that = this
      const set = this.$refs
      that.formR.audit = audit
      set[formName].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '提交审核',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          getPafss(that.formR).then(res => {
            that.$notify({
              title: '成功',
              message: '审核成功',
              type: 'success',
              duration: 2000
            })
            that.getRecordList(that.listQuery.currentPage)
            that.dialogFormReview = false
            loading.close()
          }).catch(err => {
            loading.close()
          })
        } else {
          return false
        }
      })
    },

    getSearch () {
      let that = this
      that.getRecordList()
    },
    // 取消
    cancel (formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 审核通过
    getAdopt (formName) {
      let that = this
      const set = this.$refs
      set[formName].validate(valid => {
        if (valid) {
          getPass(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '审核成功',
              type: 'success',
              duration: 2000
            })
            that.getRecordList(that.listQuery.currentPage)
            that.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 审核未通过
    getFail (formName) {
      let that = this
      const set = this.$refs
      set[formName].validate(valid => {
        if (valid) {
          getReject(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '审核成功',
              type: 'success',
              duration: 2000
            })
            that.getRecordList(that.listQuery.currentPage)
            that.dialogFormVisible = false
          })
        } else {
          return false
        }
      })
    },
    // 选择
    toExamine (e) {
      console.log('ee', e, this.form.type)
      if (e == 0) {
        this.failOrPass = true
      } else {
        this.failOrPass = false
      }
    },
    // 查询用户详情
    jumpDetails (id) {
      let that = this
      that.$router.push({
        path: '../../demo/user/userDetails',
        query: {
          id: id
        }
      })
    },
    // 查看打卡任务
    jumpTitle (id) {
      let that = this
      that.$router.push({
        path: '../../demo/punchTheClock',
        query: {
          tiltleId: id
        }
      })
    },
    // 新增
    addList () {
      this.form.attVal.push({
        attrId: null, // 账户
        value: null // 属性成长值
      })
    },
    // 删除
    removeList (index) {
      this.form.attVal.splice(index, 1)
      this.form.attVal.forEach((item, index) => {
        item.index = index
      })
    }
  }
}
</script>

<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.blue {
  color: blue;
}
.input {
  width: 200px;
}
.disDiv {
  /* display: flex; */
  border: 1px dotted;
  padding-bottom: 20px;
}
.draggable-element {
  position: fixed;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  padding: 40px;
  left: 60px;
  top: 50%;
  cursor: move;
  z-index: 999;
}
</style>
